import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutProject44ProfileList extends Layout {
    layoutheaderP44ProfileList: LayoutHeader;
    sourceP44ConfigProfile: DataSource;
    tableP44Profile: Table;
}
